import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IApiResponseBody } from '../../../common/models/common';
import { RootState } from '../../app.model';
import { booleanLookup } from '../../../common/constants/common';
import {
  deleteO365CopilotChatUsage,
  getO365CopilotChatUsageById,
  saveO365CopilotChatUsage,
  searchO365CopilotChatUsage,
} from './o365-copilot-chat-usage.action';
import { IO365CopilotChatUsageState } from './o365-copilot-chat-usage.model';
import { IO365CopilotChatUsage } from '../../../services/o365/o365-copilot-chat-usage/o365-copilot-chat-usage.model';

export const initialState: IO365CopilotChatUsageState = {
  search: {
    loading: false,
    hasErrors: false,
    data: [],
    count: 0,
    lookups: {},
    tableName: '',
  },
  tableColumnSelection: {
    id: null,
    table_name: null,
    columns: {},
  },
  getById: {
    loading: false,
    hasErrors: false,
    data: null,
  },
  save: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
  delete: {
    loading: false,
    hasErrors: false,
    messages: [],
  },
};

export const o365CopilotChatUsageSlice = createSlice({
  name: 'o365CopilotChatUsage',
  initialState,
  reducers: {
    clearO365CopilotChatUsage: () => {
      return initialState;
    },
    clearO365CopilotChatUsageMessages: (state) => {
      state.save.messages = [];
      state.delete.messages = [];
    },
    clearO365CopilotChatUsageGetById: (state) => {
      state.getById.data = null;
    },
    setTableColumnSelection: (state, action: PayloadAction<{ [key: string]: boolean }>) => {
      state.tableColumnSelection.columns = action.payload;
    },
  },
  extraReducers: {
    [searchO365CopilotChatUsage.pending.type]: (state) => {
      state.search.loading = true;
    },
    [searchO365CopilotChatUsage.fulfilled.type]: (
      state,
      action: PayloadAction<any>
    ) => {
      const payload = action.payload;
      const { search_result, ...rest } = payload;
      state.search.data = search_result.records;
      state.search.count = search_result.total_count;
      if (JSON.stringify(rest) !== '{}') {
        state.search.lookups = { ...rest, booleanLookup };
      }
      state.search.loading = false;
      state.search.hasErrors = false;
      state.search.tableName = search_result.table_name;
      if (search_result.column_selection) {
        state.tableColumnSelection.id = search_result.column_selection.id;
        const tableSelectionObj = JSON.parse(search_result.column_selection.columns as any);
        if (tableSelectionObj.columns) {
          state.tableColumnSelection.column_orders = tableSelectionObj.column_orders;
          state.tableColumnSelection.columns = tableSelectionObj.columns;
        } else {
          state.tableColumnSelection.columns = tableSelectionObj;
        }
      }
      state.tableColumnSelection.table_name = search_result.table_name;
    },
    [searchO365CopilotChatUsage.rejected.type]: (state) => {
      state.search.loading = false;
      state.search.hasErrors = true;
    },
    [getO365CopilotChatUsageById.pending.type]: (state) => {
      state.getById.loading = true;
    },
    [getO365CopilotChatUsageById.fulfilled.type]: (state, action: PayloadAction<IO365CopilotChatUsage>) => {
      state.getById.data = action.payload;
      state.getById.loading = false;
      state.getById.hasErrors = false;
    },
    [getO365CopilotChatUsageById.rejected.type]: (state) => {
      state.getById.loading = false;
      state.getById.hasErrors = true;
    },
    [saveO365CopilotChatUsage.pending.type]: (state) => {
      state.save.messages = [];
      state.save.loading = true;
    },
    [saveO365CopilotChatUsage.fulfilled.type]: (state, action: PayloadAction<IApiResponseBody<unknown>>) => {
      state.save.loading = false;
      state.save.hasErrors = false;
      state.save.messages = action.payload?.messages || [];
    },
    [saveO365CopilotChatUsage.rejected.type]: (state) => {
      state.save.loading = false;
      state.save.hasErrors = true;
    },
    [deleteO365CopilotChatUsage.pending.type]: (state) => {
      state.delete.messages = [];
      state.delete.loading = true;
    },
    [deleteO365CopilotChatUsage.fulfilled.type]: (state, action: PayloadAction<IApiResponseBody<unknown>>) => {
      state.delete.loading = false;
      state.delete.hasErrors = false;
      state.delete.messages = action.payload?.messages || [];
    },
    [deleteO365CopilotChatUsage.rejected.type]: (state) => {
      state.delete.loading = false;
      state.delete.hasErrors = true;
    },
  },
});

export const {
  clearO365CopilotChatUsage,
  clearO365CopilotChatUsageMessages,
  clearO365CopilotChatUsageGetById,
  setTableColumnSelection,
} = o365CopilotChatUsageSlice.actions;

export const o365CopilotChatUsageSelector = (state: RootState) => state.o365CopilotChatUsage;

export default o365CopilotChatUsageSlice.reducer;
